import { Component } from 'react';
import { Button, ButtonProps } from '@mui/material';
import { WithStyles, withStyles } from '@mui/styles';
import APLinkButton from './APLinkButton';
import APButtonStyles from './styles/APButton.style';

interface APButtonProps extends WithStyles<typeof APButtonStyles> {
  to?: string,
  type?: string,
  btnType?: string,
  disableHover?: boolean,
}

class APButton extends Component<APButtonProps & ButtonProps, {}> {
  render() {
    const {
      classes,
      to,
      ...otherProps
    } = this.props;

    let ButtonComponent = Button;
    if (to !== undefined) {
      ButtonComponent = (props: any) => (
        <APLinkButton to={to} {...props} />
      );
    }

    return (
      <ButtonComponent className={classes.button} {...otherProps} />
    );
  }
}

export default withStyles(APButtonStyles)(APButton);
